import { OneSignalConfiguration, OneSignalConfigurationSerialized } from '@playq/services-sonar';

import { zeroGuid } from '/constants';

export function createBlankOneSignalConfiguration(
  serialized = true
): OneSignalConfigurationSerialized | OneSignalConfiguration {
  const oneSignal = new OneSignalConfiguration();
  oneSignal.appId = zeroGuid;
  oneSignal.restApiToken = 'RESTApiTokenFromOneSignalWebsite';

  return serialized ? oneSignal.serialize() : oneSignal;
}
